// Configuración central de SEO técnico y branding de AXONIA GROUP.
// El dominio canónico absoluto del sitio público.

export const SITE_URL = "https://axoniagroup.com";
export const SITE_NAME = "AXONIA GROUP";
export const SITE_DESCRIPTION =
  "AXONIA GROUP ofrece camiones, furgonetas y autobuses para mudanzas, acarreo, distribución, eventos y servicios especiales. Solicita tu servicio en línea.";

/**
 * Logo oficial de AXONIA GROUP (imagen proporcionada por el cliente).
 * Es un SVG vectorial con fondo transparente, por lo que se mantiene nítido
 * en cualquier tamaño y en pantallas Retina/HiDPI sin perder calidad.
 * Se usa en la barra de navegación, el pie de página, el panel y el login.
 */
export const SITE_LOGO_URL =
  "https://storage.helloreaddy.io/project_files/59c72751-93ce-4410-93bb-e07d28a3d1af/c16d4b94-84ed-4cbb-98ed-689bc9bb3753_axonia-.svg";

/**
 * Ícono para el favicon de la pestaña y el guardado en el teléfono.
 * Al ser SVG conserva la transparencia y se mantiene nítido a cualquier tamaño.
 */
export const SITE_ICON_URL = SITE_LOGO_URL;

/** Imagen por defecto para compartir el enlace (Open Graph / Twitter). */
export const SITE_OG_IMAGE = SITE_LOGO_URL;

/**
 * Construye la URL canónica absoluta para una ruta pública.
 * Siempre usa HTTPS y el dominio https://axoniagroup.com
 */
export function canonicalFor(path: string): string {
  if (!path || path === "/") return `${SITE_URL}/`;
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${clean}`;
}